import { Box, Theme } from '@mui/material'
import { useTheme } from '@mui/styles'
import { JourneyType } from 'app/constants/Booking/BookingConstants'
import useQueryParams from 'hooks/useQueryParams'
import jwtDecode from 'jwt-decode'
import MiniBookingWizard from './MiniBookingWizard'
import { ProvideTwoFactor } from './useTwoFactor'

type JwtData = {
  type: any
  account: any
  plan: any
  preview: any
}

const MiniBooking = () => {
  const theme = useTheme<Theme>()

  const requiredData = {
    type: 'taxi',
    account: {
      clientId: 1,
      onBehalfOf: 6,
      mainPassenger: {
        name: 'Barry',
        email: 'barry@barrybiz.com',
        isLeadPassenger: true,
        contactNumber: '+56578865435',
        userId: null,
      },
      passengers: [
        {
          name: 'John',
          email: null,
          isLeadPassenger: false,
          contactNumber: '+5577766544',
          userId: null,
        },
      ],
    },
    plan: {
      journeyTypeName: JourneyType.ONE_WAY,
      outbound: {
        when: '2024-03-23T14:00:00.000+00:00',
        dropOff: {
          pointOfInterestTypeName: 'Airport',
          formattedAddress: 'Birmingham Airport Taxi Park',
          latitude: 52.45179565538377,
          longitude: -1.7322947352063964,
          addressLine1: 'Birmingham Airport Taxi Park',
          town: 'Birmingham',
          postCode: 'B26 3QL',
          country: 'England',
          id: 'Birmingham Airport Taxi Park',
        },
      },
    },
    preview: {
      dropOff: {
        pointOfInterestTypeName: 'Airport',
        formattedAddress: 'Birmingham Airport Taxi Park',
        latitude: 52.45179565538377,
        longitude: -1.7322947352063964,
        addressLine1: 'Birmingham Airport Taxi Park',
        town: 'Birmingham',
        postCode: 'B26 3QL',
        country: 'England',
        id: 'Birmingham Airport Taxi Park',
      },
      companyName: 'Test Company',
      passengers: [
        {
          name: 'Sue',
          email: 'sue@barrybiz.com',
          isLeadPassenger: true,
          contactNumber: '+565788667',
          userId: null,
        },
      ],
      when: '2024-03-23T14:00:00.000+00:00',
    },
  }
  console.log(JSON.stringify(requiredData))

  const params = useQueryParams()

  //Test Token for below that uses Jyrney as Client
  //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.8xCYDsxqbISbwYKv-Uxn1FRgTVbk6_vskmkifgD4nlk

  const defaultToken =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.YdQXvzU7IbJQoBM_Q-zUrymxHmprOMXHkfruEWYPWFw'

  const tokenParam = params.get('data')
  const token = tokenParam || defaultToken

  const initialData = jwtDecode<JwtData>(token)

  return (
    <ProvideTwoFactor>
      <Box
        component="div"
        sx={{
          backgroundColor: '#e8e8e8',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {theme.brand.miniBookingLogo && (
          <Box
            component="div"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#ffffff',
            }}
          >
            <Box
              component="img"
              src={theme.brand.miniBookingLogo}
              alt="Company Logo"
              sx={{
                alignSelf: 'center',
                padding: '30px 0',
                maxHeight: '150px',
                width: 'auto',

                '@media (min-width: 1000px)': {
                  maxHeight: '1500px',
                },
                '@media (min-width: 1600px)': {
                  maxHeight: '175px',
                },
              }}
            />
          </Box>
        )}
        <MiniBookingWizard initialData={initialData} />
      </Box>
    </ProvideTwoFactor>
  )
}

export default MiniBooking
